import React, { useCallback, useEffect, useState } from 'react'
import Versions from './Versions'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getVersionOptionsFetch, getVersionWordsFetch, getWorngVersionWordsFetch } from 'store/middlewares/assessment.crud'
import qc from 'keys/queryClient'
import { useParams } from 'react-router-dom'
import { types } from 'keys'
import { MarkingWordsAssessmentVM, WordVM } from 'models/VM'
import { isEqual, keyBy, sortBy } from 'lodash'
import { getTrainingWordsFetch, getWordsFetch } from 'store/middlewares/words.crud'
import { useSelector } from 'react-redux'

const VersionsPage = () => {
    const [version1, setVersion1] = useState(null)
    const [version2, setVersion2] = useState(null)
    const [wrongWords1, setWrongWords1] = useState(null)
    const [wrongWords2, setWrongWords2] = useState(null)

    const { assessment } = useSelector(state => state.assessment)

    const params = useParams()
    let assessmentID = params.assessmentID

    const assessmentVersion2 = useQuery({
        queryKey: [qc.assessmentVersion, assessmentID || ''],
        queryFn: async () => {
            const versions = await getTrainingWordsFetch({ id: assessmentID })
            const assessment = versions.data
            const mWords = []
            assessment.words.forEach((word, index) => mWords.push(new WordVM({ assessment: assessment, ...word }, index)))
            const assessmentData = { ...versions.data, words: mWords }
            if (assessmentVersion2.data)
                compareWords(assessmentData, assessmentVersion2.data)
            return assessmentData
        },
    })

    const assessmentVersion1 = useQuery({
        queryKey: [qc.assessmentVersion, assessment?.original_assessment || ''],
        queryFn: async () => {
            const versions = await getWordsFetch({ id: assessment.original_assessment })
            const mWords = []
            versions.data.words.forEach((word, index) => mWords.push(new WordVM({ assessment: assessment, ...word }, index)))
            const assessmentData = { ...versions.data, words: mWords }
            if (assessmentVersion1.data)
                compareWords(assessmentData, assessmentVersion1.data)
            return assessmentData
        },
        enabled: !!assessment?.original_assessment
    })

    const compareWords = useCallback((version1, version2) => {
        if (version1?.words && version2?.words) {
            const words1 = []

            const words2 = []

            for (let i = 0; i < version1?.words.length; i++) {
                let word1 = version1?.words[i]
                let word2 = version2?.words[i]

                if (!word1.status)
                    word1.status = types.correct
                if (!word2.status)
                    word2.status = types.correct

                if (word1.status != word2.status) {
                    words1.push(word1)
                    words2.push(word2)
                }
                else if (word1.sourceErrors?.length != word2.sourceErrors?.length) {
                    words1.push(word1)
                    words2.push(word2)
                }
                else if (word1.sourceErrors?.length && word2.sourceErrors?.length) {
                    const sortedArr1 = sortBy(word1.sourceErrors, obj => JSON.stringify(obj));
                    const sortedArr2 = sortBy(word2.sourceErrors, obj => JSON.stringify(obj));

                    if (!isEqual(sortedArr1, sortedArr2)) {
                        for (let i = 0; i < sortedArr1.length; i++) {
                            if (!isEqual(sortedArr1[i], sortedArr2[i])) {
                                words1.push(word1)
                                words2.push(word2)
                                break
                            }
                        }
                    }
                }
            }
            setWrongWords1(words1)
            setWrongWords2(words2)
        }
    }, [assessmentVersion1, assessmentVersion2])

    useEffect(() => {
        if (assessmentVersion1.data && assessmentVersion2.data)
            compareWords(assessmentVersion1.data, assessmentVersion2.data)
    }, [assessmentVersion1.data, assessmentVersion2.data])

    const commonValue = {
        version1, setVersion1,
        version2, setVersion2,
        assessmentVersion1,
        assessmentVersion2,
        wrongWords1, setWrongWords1,
        wrongWords2, setWrongWords2
    }

    return (
        <VersionsContext.Provider value={commonValue}>
            <Versions Context={VersionsContext} />
        </VersionsContext.Provider>
    )
}

export const VersionsContext = React.createContext()

export default VersionsPage